<template>
  <div id="appointModify">
    <div class="appointDiv-modify" v-if="formShow">
      <div class="cont1">
        <van-cell-group class="requried" style="width: calc(100vh - 34px);">
          <van-field
            v-model="params.businessValue"
            label="选择业务"
            placeholder="请选择业务"
            right-icon="arrow-down"
            readonly
            @click="businessShow = true"
            style="padding: 16px 0px;"
          />
        </van-cell-group>
      </div>
      <!-- 选择业务 -->
      <van-action-sheet v-model="businessShow">
        <van-picker
          show-toolbar
          :columns="businessColumns"
          @cancel="onCancel"
          @confirm="onConfirmBusiness"
        />
      </van-action-sheet>

      <div class="cont2" v-if="params.businessValue !== ''">
        <div>
          涉及{{ businessType === 1 ? "产品线(可多选)" : "业务子类(单选)"
          }}<span style="color: red;">*</span>
        </div>
        <div
          :class="item.selected === true ? 'tabblk-active' : 'tabblk'"
          v-for="(item, index) in proLineColumms"
          :key="index"
          @click="SelectProLine(item, index, businessType)"
        >
          {{ item.name }}
        </div>
      </div>

      <div style="height: 130px;background-color: #f4f5f6;"></div>
      <div class="footer-cont2">
        <van-button
          type="primary"
          block
          class="btnStyle1"
          @click.stop="saveAppoint"
          >确认无误</van-button
        >
        <van-button block class="btnStyle2" @click.stop="goBack"
          >取消</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      businessShow: false,
      areaColumns: [], // 厂区
      businessColumns: [], // 业务
      proLineColumms: [], // 产品线
      areaValue: "",
      businessValue: "",
      businessType: "", // 当前选择的业务类型
      vehicleValue: "",

      rowDataObj: {},
      formShow: true, // 表单Div显示
      timeShow: false,
      params: {
        businessId: "", // 业务id
        proLineSelect: [], // 产品线选择
        areaValue: "", // 厂区
        businessValue: "" // 业务
      }
    };
  },
  async mounted() {
    // 厂区，产品产品线信息
    let res = await this.getList();
    this.rowDataObj = res.data.data;
    this.rowDataObj.forEach(item => {
      this.areaColumns.push({
        text: item.name,
        id: item.id
      });
    });
    //  预约的详情
    let resDetail = await this.getDetail();
    let obj = resDetail.data.data;

    // 厂区-已选值
    this.params.areaValue = obj.com_id;
    let secletArea = this.rowDataObj.find(item => {
      return item.id == obj.com_id;
    });

    // 业务线
    this.businessColumns = [];
    secletArea.business.forEach(item => {
      if (item.type == 1) {
        this.businessColumns.push({
          text: item.name,
          id: item.id,
          type: item.type,
          selective_type: item.selective_type,
          sub_buness: item.sub_buness,
          vehicle_type: item.vehicle_type
        });
        // 理论上只有一个，默认选中
        this.params.businessId = item.id;
      }
    });

    // 业务线-已选值
    // this.params.businessId = obj.business_id;
    let businessColumnItem = this.businessColumns.find(item => {
      return item.id == this.params.businessId;
    });
    this.params.businessValue = businessColumnItem.text;
    this.businessType = businessColumnItem.selective_type;

    // 产品线
    this.proLineColumms = [];
    businessColumnItem.sub_buness.forEach(item => {
      this.proLineColumms.push({
        id: item.id,
        name: item.name,
        type: item.type,
        selective_type: this.businessType,
        selected: false
      });
    });
  },
  beforeRouteUpdate(a, b, n) {
    n();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onCancel() {
      this.businessShow = false;
    },

    // 确认选择业务
    onConfirmBusiness(val) {
      this.businessShow = false;
      if (val.text == "暂无数据") {
        return false;
      }
      this.params.businessValue = val.text;
      this.businessType = val.selective_type;
      this.params.businessId = val.id;
      this.params.proLineSelect = []; // 产品线选择清空
      this.proLineColumms = []; // 产品线列表
      val.sub_buness.forEach(item => {
        this.proLineColumms.push({
          id: item.id,
          name: item.name,
          type: item.type,
          selective_type: val.selective_type,
          selected: false
        });
      });
    },

    // 选择产品线
    SelectProLine(item, index, tag) {
      this.params.proLineSelect = [];
      if (Number(tag) === 1) {
        // 多选
        this.proLineColumms[index].selected = !item.selected;
        for (let i = 0; i < this.proLineColumms.length; i++) {
          if (this.proLineColumms[i].selected) {
            this.params.proLineSelect.push(this.proLineColumms[i]);
          }
        }
      } else {
        // 单选
        for (let i = 0; i < this.proLineColumms.length; i++) {
          this.proLineColumms[i].selected = false;
        }
        this.proLineColumms[index].selected = !item.selected;
        if (this.proLineColumms[index].selected) {
          this.params.proLineSelect.push(this.proLineColumms[index]);
        }
      }
    },

    // 保存预约信息
    saveAppoint() {
      if (this.params.businessValue.trim() === "") {
        this.$common.mbToastFail("请选择业务");
        return false;
      }
      if (this.businessType === 1 && this.params.proLineSelect.length === 0) {
        this.$common.mbToastFail("请至少选择一个产品线");
        return false;
      }
      if (this.businessType === 0 && this.params.proLineSelect.length === 0) {
        this.$common.mbToastFail("请选择业务子类");
        return false;
      }

      let business_ids = [];
      this.params.proLineSelect.forEach(item => {
        business_ids.push(item.id);
      });

      let data = {
        id: this.info_id,
        business_ids: JSON.stringify(business_ids)
      };
      this.$common
        .http({
          url: "/api/queue/dispatcher/join_finished_product_business",
          data: data
        })
        .then(() => {
          this.$common.mbToastSuccess("保存成功");
          this.goBack();
        });
    },

    // 获取厂区，业务等列表
    getList() {
      return this.$common.http({
        url: "/api/queue/dispatcher/get_booking_data",
        data: {}
      });
    },

    // 获取详情
    getDetail() {
      return this.$common.http({
        url: "/api/queue/dispatcher/get_booking_detail",
        data: {
          info_id: this.info_id
        }
      });
    }
  },

  created() {},

  computed: {
    info_id() {
      return this.$route.query.info_id;
    },
    id() {
      return this.$route.query.id;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.appointDiv-modify {
  min-height: calc(100vh - 1px);
  border-top: 1px solid #f4f5f6;
  background: #f4f5f6;
  font-size: 16px;
  .cont1 {
    line-height: 54px;
    background: #fff;
    display: flex;
    padding: 0px 15px;
    margin-bottom: 10px;
    .left {
      flex: 1;
    }
    .right {
      flex: 0.5;
      text-align: right;
    }
  }
  .cont2 {
    padding: 20px 16px;
    background: #fff;
    margin-bottom: 10px;
    .tabblk-active {
      display: inline-block;
      background: #00c8d2;
      color: #fff;
      margin: 14px 20px 0px 0px;
      padding: 6px 11px;
      border-radius: 20px;
    }
    .tabblk {
      display: inline-block;
      background: #f7f7f7;
      color: #999999;
      margin: 14px 20px 0px 0px;
      padding: 6px 11px;
      border-radius: 20px;
    }
  }
  .cont3 {
    padding: 16px;
    background: #fff;
    margin-bottom: 10px;
    .car-license {
      &-title {
        margin: 4px 0px 20px;
        font-size: 17px;
      }
      &-btn-active {
        display: inline-block;
        background: #00c8d2;
        color: white;
        font-size: 13px;
        padding: 9px 18px;
        border-radius: 4px;
        margin: 0px 14px 24px 0px;
      }
      &-btn {
        display: inline-block;
        background: #f6f6f7;
        color: #00c8d2;
        font-size: 13px;
        padding: 9px 18px;
        border-radius: 4px;
        margin: 0px 14px 24px 0px;
      }
    }
  }
  .cont4 {
    margin-bottom: 10px;
  }

  .cont5 {
    background: #fff;
    margin-bottom: 10px;
    padding: 16px;
    font-size: 18px;
  }

  .cont6 {
    background: #fff;
    padding: 16px 0px;
  }

  .cont7 {
    display: flex;
    justify-content: center;
    font-size: 13px;
    color: #008b5e;
    text-align: center;
    margin-bottom: 10px;
    & > div {
      flex: 1;
    }
    &-btn {
      background: #cce8df;
      border-radius: 4px;
      display: inline-block;
      padding: 7px 21px;
    }
  }
}
.timeDiv {
  height: 100%;
  width: 100%;
  overflow: auto;
  background-color: #f4f5f6;
  font-size: 16px;
  .cont1 {
    line-height: 56px;
    background: #fff;
    display: flex;
    padding: 0px 15px;
    margin-bottom: 10px;
    height: 56px;
    .left {
      flex: 1;
    }
    .right {
      flex: 0.5;
      text-align: right;
      font-size: 20px;
    }
  }
  .cont2 {
    background: #fff;
    display: flex;
    font-size: 18px;
    padding: 16px;
    align-items: center;
    &-first {
      width: calc(100vw - 216px) !important;
      // flex: 1.1 !important;
      text-align: left !important;
    }
    & > div {
      // flex: 1;
      width: 97px;
      text-align: center;
      margin-right: 13px;
    }
  }
  .cont3 {
    background: #fff;
    display: flex;
    padding: 0px 16px 20px;
    align-items: center;
    // line-height: 43px;
    padding: 0px 16px;
    height: 43px;
    &-first {
      flex: 1.1;
      text-align: left !important;
      word-break: break-all;
    }
    &-second {
      color: #ec3f67;
      width: 97px;
      text-align: center;
    }
    &-third {
      color: #008b5e;
      width: 97px;
      text-align: center;
    }
    &-forth {
      width: 16px;
      text-align: center;
    }
  }
  .pd40 {
    padding-bottom: 36px;
  }
  .bg456 {
    background: #f7f7f7;
  }
  .calendar-cont {
    height: 36px;
    font-size: 14px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: #009967;
    background: #f7f7f7;
    box-shadow: 0px 2px 20px rgba(125, 126, 128, 0.16);
  }
}
.mainDiv {
  background: #fff;
}
</style>
<style lang="less">
.appointDiv-modify {
  .van-cell {
    font-size: 16px;
  }
  .van-field__label {
    color: #000;
  }
  .van-button--round {
    border-radius: 4px;
  }
  .van-calendar__popup.van-popup--bottom,
  .van-calendar__popup.van-popup--top {
    height: 71%;
  }

  .van-uploader__preview {
    margin: 0px;
    width: 100%;
  }
  .van-uploader__preview-image {
    width: inherit;
    height: inherit;
    object-fit: cover;
    vertical-align: top;
    // width: calc((100vw - 42px) / 2);
    height: calc((100vw - 42px) / 3.4);
    border-radius: 2px;
  }
  .van-button--round {
    border-radius: 4px;
  }
  .van-image__error,
  .van-image__img,
  .van-image__loading {
    width: 100%;
  }
  .van-uploader {
    width: 100%;
  }
  .van-uploader__input-wrapper {
    width: 100%;
  }
  .van-uploader__preview-delete-icon {
    font-size: 27px;
  }
  .van-uploader__preview-delete {
    border-radius: 0 2px 0 27px !important;
  }
  .van-uploader__preview-delete {
    width: 27px;
    height: 27px;
    background-color: red;
  }
  .card-img-div {
    color: #999999;
    font-size: 14px;
    background: #f4f5f6;
    display: inline-block;
    object-fit: cover;
    // width: calc((100vw - 42px) / 2);
    height: calc((100vw - 42px) / 3.4);
    width: 100%;
    vertical-align: text-bottom;
    border-radius: 2px;
    &-icon {
      text-align: center;
      top: 50%;
      position: relative;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .card-img {
    object-fit: cover;
    vertical-align: top;
    // width: calc((100vw - 42px) / 2);
    // height: calc((100vw - 42px) / 3.4);
  }
}
#appointModify {
  #appointModifyCal .van-calendar__popup.van-popup--left,
  .van-calendar__popup.van-popup--right {
    height: 460px;
    margin: 0px 30px;
    // right: 50%;
    // transform: translate3d(50%, -50%, 0);
  }
  #appointModifyCal .van-calendar__footer {
    padding: 0px;
  }
}
</style>
